<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Welcome back, please login to your account.</p>
                                </div>

<!--                              <vs-input-->
<!--                                v-validate="'required|digits:10'"-->
<!--                                data-vv-validate-on="blur"-->
<!--                                name="phone"-->
<!--                                icon="icon icon-phone"-->
<!--                                icon-pack="feather"-->
<!--                                label-placeholder="Телефон"-->
<!--                                v-model="phone"-->
<!--                                class="w-full no-icon-border"/>-->
<!--                              <span class="text-danger text-sm">{{ errors.first('phone') }}</span>-->

                              <vx-input-group class="mb-6">
                                <template slot="prepend">
                                  <div class="prepend-text bg-primary">
                                    <span>+38</span>
                                  </div>
                                </template>

                                <vs-input v-validate="'required|digits:10'"
                                          data-vv-validate-on="blur"
                                          name="phone"
                                          icon="icon icon-phone"
                                          icon-pack="feather"

                                          v-model="phone"
                                          class="w-full no-icon-border" />

                              </vx-input-group>
                              <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
<!--                                <vs-input-->
<!--                                    data-vv-validate-on="blur"-->
<!--                                    v-validate="'required|min:6|max:10'"-->
<!--                                    type="password"-->
<!--                                    name="password"-->
<!--                                    icon="icon icon-lock"-->
<!--                                    icon-pack="feather"-->
<!--                                    label-placeholder="Password"-->
<!--                                    v-model="password"-->
<!--                                    class="w-full mt-6 no-icon-border" />-->
<!--                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>-->


                              <div class="flex flex-wrap justify-between my-5">
                                <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Запомнить меня</vs-checkbox>
                                <vs-button class="float-right mt-6" @click="sendOtp" :disabled="!validateForm">Получить SMS</vs-button>
                              </div>
                              <div id="recaptcha-container"></div><br>

                              <vs-input
                                v-validate="'required|digits:6'"
                                data-vv-validate-on="blur"
                                name="otp"
                                icon="icon icon-phone"
                                icon-pack="feather"
                                label-placeholder="SMS код"
                                v-model="otp"
                                class="w-full no-icon-border"/>
                              <span class="text-danger text-sm">{{ errors.first('digits') }}</span>

                              <div class="flex flex-wrap justify-between my-5">

                                <vs-button class="float-right mt-6" @click="verifyOtp" :disabled="!validateOtp">Подтвердить</vs-button>

                              </div>



                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
 import {firebase} from '@/firebase'
export default {
    data() {
        return {
            phone: '096000000',
            appVerifier : '',
            otp : '',
            checkbox_remember_me: true,
            countryCode: '+38',
            // test: false
        }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.phone !== '';
      },
      validateOtp() {
        return !this.errors.any() && this.otp !== '';
      }
    },
    methods: {
      sendOtp() {
        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          userDetails: {
            phone: this.countryCode + this.phone,
            appVerifier: this.appVerifier
          },

        };
        this.$store.dispatch('auth/loginAttempt', payload);

      },

      verifyOtp(){
        if(this.phone.length !== 10 || this.otp.length !== 6){
          // alert('Invalid Phone Number/OTP Format !');
          this.$vs.notify({
            title: 'Ошибка ввода',
            text: 'Вы не правильно ввели номер телефона или SMS!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }else{
          const payload = {
            code : this.otp,
            phone : this.countryCode + this.phone,
            notify: this.$vs.notify
          };
          this.$store.dispatch('auth/attemptConfirm', payload);

        }
      },
      initReCaptcha(){
        setTimeout(()=>{
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
            },
            'expired-callback': function() {
            }
          });
          //
          this.appVerifier =  window.recaptchaVerifier
        },1000)
      },
      notifyAlreadyLogedIn() {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        });
      },
    },
  created(){
    this.initReCaptcha()
  }
}
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
